<template>
  <div class="con_content">
    <div class="container">
      <div class="container_top h_48">音频管理</div>
      <div>
        <!-- table组件 -->
        <div class="my_table">
          <Table border :columns="columns" :data="data" ref="table">
            <template slot-scope="{ row }" slot="thumb">
              <img :src="row.thumb" class="table_img" />
            </template>
            <template slot-scope="{ row }" slot="btn">
              <span>
                <Poptip trigger="hover" content="编辑">
                  <Button
                    class="padlr5"
                    size="small"
                    @click="route='/layout/circle/audio/hj_edit';btn_name='hj_editor';btn(row)"
                    type="success"
                    icon="md-open"
                  ></Button>
                </Poptip>
              </span>
            </template>
          </Table>
        </div>
        <div class="my_table" style="margin-top: 40px">
          <Row class="search_row">
            <div class="search_name">
              <Button
                class="mR5"
                type="info"
                @click="route='/layout/circle/audio/yp_add';btn_name='yp_add';btn('')"
              >
                <Icon type="md-add" />添加
              </Button>
            </div>
          </Row>
        </div>
        <div class="my_table">
          <Table border :columns="columns1" :data="data1" ref="table">
            <!-- 封面图 -->
            <template slot-scope="{ row }" slot="thumb">
              <img :src="row.thumb" class="table_img" />
            </template>
            <!-- 播放试听 -->
            <template slot-scope="{ row }" slot="url">
              <span>
                <!-- <audio :src="row.url"  controls> </audio> -->
                <!--vue-aplayer插件-->
                <aplayer
                  :music="{
                        title: row.name,
                        author: '♬',
                        url: row.url,
                        pic: row.thumb,
                        
                        preload: 'metadata'
                    }"
                ></aplayer>
              </span>
            </template>
            <template slot-scope="{ row }" slot="btn">
              <span>
                <Poptip trigger="hover" content="编辑">
                  <Button
                    class="padlr5"
                    size="small"
                    @click="route='/layout/circle/audio/yp_edit';btn_name='yp_editor';btn(row)"
                    type="success"
                    icon="md-open"
                  ></Button>
                </Poptip>
               
                <Poptip trigger="hover" content="删除">
                  <Button
                    class="padlr5"
                    size="small"
                    @click="route='/layout/circle/audio/yp_del';del(row)"
                    type="error"
                    icon="md-close"
                  ></Button>
                </Poptip>
              </span>
            </template>
          </Table>
        </div>
      </div>
    </div>

    <!-- 添加音频,编辑音频,删除音频 -->
    <Modal v-model="m_bool" :title="title" class-name="vertical-center-modal" width="520">
      <div slot="footer">
        <Button type="text" size="large" @click="close()">取消</Button>

        <Button v-if="btn_name == 'hj_editor'" type="primary" size="large" @click="hj_editor()">修改</Button>
        <Button v-if="btn_name == 'yp_add'" type="primary" size="large" @click="yp_add()">添加</Button>
        <Button v-if="btn_name == 'yp_editor'" type="primary" size="large" @click="yp_editor()">修改</Button>
      </div>

      <ul class="layout_ul" v-if="btn_name == 'hj_editor'">
        <li>
          <div class="list_title">
            <span class="cRed"></span> 名称 :
          </div>
          <div class="list_con">
            <Input v-model="my_row.title" type="text" class="ipt" placeholder="请输入名称" />
          </div>
        </li>
        <li>
          <div class="list_title">
            <span v-if="out_btn_num == 0" class="cRed">*</span> 图片 :
          </div>
          <div class="list_con">
            <img :src="my_row.thumb?my_row.thumb:'/images/login_logo.png'" alt style="width:110px" />
            <cropper @childFun="childFun2" :data="cropper_data1"></cropper>
          </div>
        </li>
      </ul>
      <ul class="layout_ul" v-if="btn_name == 'yp_editor' || btn_name == 'yp_add'">
        <!-- 标题 -->
        <li>
          <div class="list_title">
            <span v-if="btn_name == 'yp_add'" class="cRed">*</span> 音频名称 :
          </div>
          <div class="list_con">
            <Input v-model="my_row.title" type="text" class="ipt" placeholder="请输入音频名称" />
          </div>
        </li>
       
        <!-- 上传附件 -->
        <li>
          <div class="list_title">
            <span v-if="btn_name == 'yp_add'" class="cRed">*</span> 上传图片 :
          </div>
          <div class="list_con">
            <img :src="my_row.thumb?my_row.thumb:'/images/login_logo.png'" style="width:110px" />
            <cropper
              v-if="btn_name == 'yp_add' || btn_name == 'yp_editor'"
              @childFun="childFun2"
              :data="cropper_data2"
            ></cropper>
          </div>
        </li>
 <!-- 上传音频 -->
        <li>
          <div class="list_title">
            <span v-if="btn_name == 'yp_add'" class="cRed">*</span> 上传音频 :
          </div>
          <div class="list_con relative">
            <div class="upmusic_zz" v-if="!music_setTime" @click="zzFun"></div>
            <Upload
              :format="['wma','mp3','ogg']"
              :headers="{'Authorization':'Bearer ' + token}"
              :data="{guid: my_guid,type:'9'}"
              :on-success="up_succ"
              action="https://api.jiapuji.vip/gateway/attached/service/attached/upload"
              
              :before-upload="handleUpload"
              ref="uploadButton"
            >
            <!-- :max-size="102400" -->
              <Button type="info" icon="md-cloud-upload">上传音频</Button> <span class="cRed" style="margin-left: 28px">*请上传MP3文件 </span>
            </Upload>
          </div>
        </li>
        <!-- 是否隐藏 -->
        <li>
          <div class="list_title">
            <span v-if="btn_name == 'yp_add'" class="cRed">*</span> 显示状态 :
          </div>
          <div class="list_con">
            <i-switch
              class="mSwitch"
              v-model="my_row.display"
              :true-value="Number(1)"
              :false-value="Number(0)"
            />
          </div>
        </li>
        <!-- 排序 -->
        <li>
          <div class="list_title">
            <span v-if="btn_name == 'yp_add'" class="cRed">*</span> 排序 :
          </div>
          <div class="list_con">
            <Input
              v-model="my_row.listorder"
              type="number"
              class="ipt"
              placeholder="请输入排序"
              style="width: 150px"
            />
          </div>
        </li>
      </ul>
    </Modal>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import cropper from "../../child_vue/vue_cropper.vue";
import aplayer from "vue-aplayer";

const yp_form = {
  title: "",
  thumb: "",
  display: 1,
  listorder: 0
};
export default {
  name: "audios",
  data() {
    return {
      token: null,
      route: null,
      guid: "better",

      btn_name: "",
      title: "",
      m_bool: false,
      my_row: {},
      // 合辑
      columns: [],
      data: [],

      //音频
      columns1: [],
      data1: [],

      music_setTime: true, //音频未上传好不能点击添加修改

      // 上传图片

      cropper_data1: {
        btn_name: "上传图片",
        outputType: "jpeg", //生成图片格式
        type: "17",
        vCropper: "5",
        enlarge: "1.5",
        autoCropWidth: "200",
        autoCropHeight: "200"
      },
      cropper_data2: {
        btn_name: "上传图片",
        outputType: "jpeg", //生成图片格式
        type: "16",
        vCropper: "4",
        enlarge: "1",
        autoCropWidth: "200",
        autoCropHeight: "200"
      },

      child_val: null, //child 反馈
      pic: {},

      voice: {}
    };
  },

  watch: {
    title_num(val) {
      let that = this;
      that.load1();
    }
  },
  components: {
    aplayer,
    cropper
  },
  computed: {},

  methods: {
    hj_load() {
      let that = this;
      that.$myAjax.get("admin/service/album/detail").then(res => {
        that.data = res.data.data;
        that.columns = [
          { title: "ID", key: "id", align: "center", width: 80 },
          { title: "名称", key: "title", align: "center", minWidth: 100 },
          { title: "图片", slot: "thumb", align: "center", minWidth: 100 },

          {
            title: "操作",
            slot: "btn",
            align: "center",
            width: 160,
            fixed: "right"
          }
        ];
        that.data = res.data.data;

        that.out_model2 = that.data[0].guid;
      });
    },
    yp_load() {
      let that = this;
      let data = {
        guid: that.guid,
        page: that.page,
        size: that.size,
        type: "1"
      };

      that.$myAjax.get("admin/service/audio/list").then(res => {
        this.data1 = res.data.data;
        that.columns1 = [
          { title: "ID", key: "id", align: "center", width: 80 },
          {
            title: "名称",
            key: "title",
            align: "center",
            minWidth: 100,
            maxWidth: 250
          },
          {
            title: "封面图",
            slot: "thumb",
            align: "center",
            minWidth: 100,
            maxWidth: 250
          },
          { title: "播放试听", slot: "url", align: "center", minWidth: 300 },
          {
            title: "时间",
            key: "timeLength",
            align: "center",
            minWidth: 90,
            maxWidth: 120
          },
          {
            title: "排序",
            key: "listorder",
            align: "center",
            minWidth: 90,
            maxWidth: 120
          },
          {
            title: "播放量",
            key: "playNum",
            align: "center",
            minWidth: 90,
            maxWidth: 120
          },

          {
            title: "状态",
            key: "display",
            align: "center",
            width: "110",
            render: (h, params) => {
              return h(
                "i-switch",
                {
                  props: {
                    size: "large",
                    value: params.row.display,
                    "true-value": 1,
                    "false-value": 0
                  },
                  on: {
                    "on-change": value => {
                      that.$myAjax
                        .put(
                          "admin/service/audio/changeStatus?route=/layout/circle/audio/yp_edit",
                          {
                            id: params.row.id,
                            display: value
                          }
                        )
                        .then(res => {
                          that.yp_load();
                        })
                        .catch(err => {
                          console.log(err);
                        });
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: "开启"
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: "关闭"
                    }
                  })
                ]
              );
            }
          },

          {
            title: "创建日期",
            key: "createTime",
            align: "center",
            minWidth: 120,
            maxWidth: 220
          },
          {
            title: "操作",
            slot: "btn",
            align: "center",
            width: 130,
            fixed: "right"
          }
        ];
      });
    },
    // 添加，编辑
    btn(row) {
      this.my_row = row;
      switch (this.btn_name) {
        case "hj_editor":
          this.title = "合辑编辑";
          break;
        case "yp_editor":
          this.title = "音频编辑";
          break;
        case "yp_add":
          this.title = "音频添加";
          this.my_row = yp_form;
          break;
      }
      this.m_bool = true;
    },
    // 删除
    del(row) {
      this.$Modal.error({
        title: "删除",
        content:
          "<p>确定删除<span style='color:red'>" + row.title + "</span>吗?</p>",
        onOk: () => {
          this.$myAjax
            .delete(
              "admin/service/audio/del?route=" + this.route + "&id=" + row.id
            )
            .then(res => {
              if (res.data.code == 1) {
                this.close();
              }
            });
        }
      });
    },

    //上传音频
    up_succ(opt) {
      let that = this;
      this.voice = {
        name: opt.data.name,
        path: opt.data.path
      };

      that.$refs.uploadButton.clearFiles();
      that.music_setTime = true;

      // that.music_setTime = true;
    },

    handleUpload(file) {
      //选中音频后
      let that = this;
      that.music_setTime = false;
    },
    zzFun() {
      let that = this;
      this.$Message.info({
        content: "音频上传中",
        duration: 3
      });
    },
    // 上传图片反馈
    childFun2(data) {
      let that = this;
      that.$upload(data.pic_url).then(res => {
        let name = res.data.data.name;
        let path = res.data.data.path;
        this.pic = {
          name: name,
          path: path
        };
        this.my_row.thumb = path;
        console.log(this.my_row.thumb);
      });
    },
    // 关闭弹窗
    close() {
      this.m_bool = false;
      setTimeout(() => {
        this.hj_load(); //合辑
        this.yp_load(); //音频
      }, 500);
    },
    // 合辑编辑
    hj_editor() {
      let my_row = JSON.parse(JSON.stringify(this.my_row));

      my_row.thumb = this.pic.name;

      this.$myAjax.put("admin/service/album/edit", my_row).then(res => {});

      this.close();
    },
    // 音频添加
    yp_add() {
      let my_row = JSON.parse(JSON.stringify(this.my_row));
      my_row.thumb = this.pic.name;
      my_row.url = this.voice.name;
      if (!my_row.title) {
        this.$Message.info({
          content: "请输入名称",
          duration: 3
        });
      } else if (!my_row.thumb) {
        this.$Message.info({
          content: "请上传图片",
          duration: 3
        });
      }else if(!my_row.url){
        this.$Message.info({
          content: "请上传音频",
          duration: 3
        });
      } else {
        this.$myAjax.post("admin/service/audio/add", my_row).then(res => {});
        this.close();
      }

      
    },
    // 音频编辑
    yp_editor() {
      let my_row = JSON.parse(JSON.stringify(this.my_row));
      this.$myAjax.put("admin/service/audio/edit", my_row).then(res => {});
      my_row.thumb = this.pic.name;
      my_row.url = this.voice.name;
      this.close();
    }
  },
  mounted: function() {
    let that = this;
    that.my_guid = that.$store.state.guid;

    that.token = that.$store.state.token;
    that.hj_load(); //合辑
    that.yp_load(); //音频
  }
};
</script>
<style scoped>
.upmusic_zz {
  position: absolute;

  top: 0;
  left: 0;
  /* background:red; */
  width: 120px;
  height: 100%;
  z-index: 9999;
}
.table_img {
  height: 66px;
  margin-top: 5px;
}
</style>